import axios from 'axios'
import router from '@/router'
import i18n from '@/i18n'

const UNAUTHORIZED_URLS = [
  '/api/auth/login/azure',
  '/api/auth/login',
  '/api/auth/register-incomplete-account',
  '/api/auth/otp-verify'
]

const instance = axios.create({
  baseURL: `${process.env.VUE_APP_BACKEND_URL}`,
  timeout: 1000000
})

const refreshInstance = axios.create({
  baseURL: `${process.env.VUE_APP_BACKEND_URL}`,
  timeout: 10000
})

const refresh = async (originalRequest) => {
  try {
    const { data } = await refreshInstance.post('/api/auth/refresh', null, {
      params: {
        token: localStorage.getItem('token'),
        refreshToken: localStorage.getItem('refreshToken')
      }
    })
    localStorage.setItem('token', data.token)
    return instance({
      ...originalRequest,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    })
  } catch (error) {
    localStorage.clear()
    router.replace(`/${i18n.locale}`)
    return Promise.reject(error)
  }
}

instance.interceptors.request.use(req => {
  if (!UNAUTHORIZED_URLS.includes(req.url)) {
    req.headers.Authorization = `Bearer ${localStorage.getItem('token')}`
  }
  return req
})

instance.interceptors.response.use(
  response => response,
  error => {
    const loginRequest = error.config.url.endsWith('/auth/login/azure') ||
    error.config.url.endsWith('/auth/otp-verify') ||
    error.config.url.endsWith('/auth/login')
    const unauthorized = error.response.status === 401

    const permission = error.response.status === 403
    if (!loginRequest && unauthorized) {
      return refresh(error.config)
    }

    if (permission) {
      router.replace(`/${i18n.locale}/permission-error`)
    }

    return Promise.reject(error)
  }
)

export default instance
